import * as React from 'react';
import {Rnd} from "react-rnd";
import { Frame } from "@/components/frames";
import {useEffect, useRef, useState} from "react";
import ClearIcon from '@mui/icons-material/Clear';
import cloneDeep from "lodash.clonedeep";
import {IconButton} from "@mui/material";

export const ScaleAndDrag = ({ config, onSelect, selected, onDragStart, onDragStop, onResizeStop, onRemove, children }) => {
    const originalEl = useRef(null)
    const cloneEl = useRef(null)

    const [resizing, setResizing] = useState(false)

    const [scale, setScale] = useState(config?.css?.scale ?? 1)
    const [width, setWidth] = useState('auto')
    const [height, setHeight] = useState('auto')

    useEffect(() => {
        setWidth((originalEl.current.clientWidth + 1) * scale)
        setHeight(originalEl.current.clientHeight * scale)
    }, [])

    const handleRemove = () => {
        onRemove?.();
    }

    const handleDragStop = (e, data) => {
        if (!resizing) {
            onDragStop?.({
                x: Math.round(data.lastX),
                y: Math.round(data.lastY),
            })
        }
    }

    const handleResizeStop = (e, dir, ref, delta, position) => {
        setResizing(false);
        // const scale = originalEl.current.clientWidth / cloneEl.current.clientWidth;
        const localScale = ref.clientWidth / originalEl.current.clientWidth;

        setScale(localScale);

        setWidth(ref.clientWidth)
        setHeight(ref.clientHeight)

        onResizeStop?.({
            x: Math.round(position.x),
            y: Math.round(position.y),
            scale: localScale,
            width: ref.clientWidth,
            height: ref.clientHeight,
        })
    }

    return (
        <Rnd
            // default={{
            //     x: it.coords[0],
            //     y: it.coords[1],
            //     width: it?.size ? it.size.width : 'auto',
            //     height: it?.size ? it.size.height : 'auto',
            // }}
            default={{
                x: config?.css?.x ? config?.css?.x : 0,
                y: config?.css?.y ? config?.css?.y : 0,
                width: 'auto',
                height: 'auto',
            }}
            size={{ width: 'auto', height: 'auto' }}
            disableDragging={false}
            onResizeStart={() => setResizing(true)}
            onResizeStop={handleResizeStop}
            // onDragStart={handleDragStart}
            onDragStop={handleDragStop}
            enableResizing={{
                bottomRight: true,
            }}
            lockAspectRatio={config.type === 'image' ? false : true}
            bounds="parent"
            className={'selected_frame'}
            resizeHandleClasses={{
                bottom: 'edge edge-b',
                bottomLeft: 'corner',
                bottomRight: 'corner',
                left: 'edge edge-l',
                right: 'edge edge-r',
                top: 'edge edge-t',
                topLeft: 'corner',
                topRight: 'corner',
            }}
        >
            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                width: width,
                height: height,
            }}
            >
                <div ref={originalEl} style={{
                    transform: config.type === 'image' ? null : `scale(${scale})`,
                    transformOrigin: config.type === 'image' ? null : '0 0',
                    width: config.type === 'image' ? '100%' : null,
                    height: config.type === 'image' ? '100%' : null,
                }}>
                    {children}
                </div>
                <div className={'delete_widget'} style={{
                    position: 'absolute',
                    top: '-12px',
                    right: '-12px',
                }}>
                    <IconButton color="secondary" size="small" sx={{ p: 0}} onTouchEnd={handleRemove}>
                        <ClearIcon />
                    </IconButton>
                </div>
            </div>
        </Rnd>
    );
}
